import React  from "react";
import PropTypes from 'prop-types';
import { DragDropContext } from "react-beautiful-dnd";
import update from "immutability-helper";
import {Card, CardBody, CardHeader} from "reactstrap";
import ColumnsList from "./ColumnsList";
import useAfterUpdateEffect from "../../../../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const TableColumns = (props) => {
  const { t } = useTranslation('app_table')
  const [columnsActive, setColumnsActive] = React.useState(props.columns.filter(column => column.isActive));
  const [columnsNotActive, setColumnsNotActive] = React.useState(props.columns.filter(column => !column.isActive));

  useAfterUpdateEffect(() => {
    const columns = [
      ...columnsActive,
      ...columnsNotActive,
    ];

    props.onColumnsUpdate(columns)
  }, [columnsActive, columnsNotActive])

  const getColumnsUseState = (columnsType) => {
    switch(columnsType) {
      case 'active': return {
        setterFn: setColumnsActive,
        columns: columnsActive,
      };
      case 'notActive': return {
        setterFn: setColumnsNotActive,
        columns: columnsNotActive,
      };
    }
  }

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    const sInd = source.droppableId;
    const dInd = destination.droppableId;

    if (sInd === dInd) {
      const columnsUseState = getColumnsUseState(sInd);

      columnsUseState.setterFn(update(columnsUseState.columns, {
        $splice: [
          [source.index, 1],
          [destination.index, 0, columnsUseState.columns[source.index]],
        ],
      }))
    } else {
      switch(sInd) {
        case 'notActive': {
          const column = columnsNotActive[source.index];

          setColumnsNotActive(update(columnsNotActive, {
            $splice: [[source.index, 1]]
          }))
          columnsActive.splice(destination.index, 0, {
            ...column,
            isActive: true,
          })
          setColumnsActive(columnsActive)

          break;
        }
        case 'active': {
          const column = columnsActive[source.index];

          setColumnsActive(update(columnsActive, {
            $splice: [[source.index, 1]]
          }))
          columnsNotActive.splice(destination.index, 0, {
            ...column,
            isActive: false,
          })
          setColumnsNotActive(columnsNotActive)

          break;
        }
      }
    }
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="d-flex flex-row flex-nowrap">
        <Card className="flex-grow-1 w-50">
          <CardHeader>{t('table_settings.header_active_columns')}</CardHeader>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between px-3">
              <span className="text-secondary">{t('table_settings.column_name')}</span>
              <span className="text-secondary">{t('table_settings.column_width')}</span>
            </div>
            <ColumnsList
              id={'active'}
              columns={columnsActive}
              onColumnUpdate={(index, column) => setColumnsActive(update(columnsActive, { [index]: {$set: column} }))}
            />
          </CardBody>
        </Card>
        <i className="fas fa-arrows-alt-h fa-2x my-auto px-4" />
        <Card className="flex-grow-1 w-50">
          <CardHeader>{t('table_settings.header_available_columns')}</CardHeader>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between px-3">
              <span className="text-secondary">{t('table_settings.column_name')}</span>
            </div>
            <ColumnsList
              id={'notActive'}
              columns={columnsNotActive}
              onColumnUpdate={(index, column) => setColumnsActive(update(columnsActive, { [index]: {$set: column} }))}
            />
          </CardBody>
        </Card>
      </div>
    </DragDropContext>
  );
}

TableColumns.propTypes = {
  onColumnsUpdate: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
};

export default TableColumns;
